import { CommonModule } from '@angular/common';
import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RouterModule } from '@angular/router';
import { AuthService } from '../../../../core/auth/auth.service';
import { HeaderComponent } from '../header/header.component';
import { NavigationComponent } from '../navigation/navigation.component';

@Component({
  selector: 'app-main-layout',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    HeaderComponent,
    NavigationComponent,
  ],
  templateUrl: './main-layout.component.html',
})
export class MainLayoutComponent implements OnInit {
  doctorName: string | null = null;

  private authService = inject(AuthService);
  private destroyRef = inject(DestroyRef);

  constructor() { }

  ngOnInit(): void {
    this.authService.getLoggedInUser()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(user => {
        if (user.firstName && user.lastName) {
          this.doctorName = `${user.firstName} ${user.lastName}`;
        } else if (user.displayName) {
          this.doctorName = user.displayName;
        } else {
          this.doctorName = null;
        }
      });
  }
}
